var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"serve-manage"},[_c('TopBar'),_c('WrapManage',{attrs:{"title":"平台服务管理"}},[_c('WrapContent',{attrs:{"img":_vm.iconRefuse,"title":"目前该服务仅面向POP商家开放，其他合作模式商家尚未开放"}},[_c('BtnList',{attrs:{"text":"我知道了","nums":"1"},on:{"handle":_vm.iKnow}})],1)],1),_c('FootBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }